import { LuCkeditorOptions } from '../../lu-ckeditor.models';

export const insertInToolbar = (options: Partial<LuCkeditorOptions>) => {
	let insertItems = [];

	if (options.addImageUploadViaDj) {
		insertItems = [...insertItems, 'djimage'];
	} else if (options.addImageUpload) {
		insertItems = [...insertItems, 'Image'];
	}

	if (options.addEmbeddedMedia) {
		insertItems = [...insertItems, 'MediaEmbed'];
	}

	if (options?.insertInToolbar?.length) {
		insertItems = [...insertItems, ...options.insertInToolbar];
	}

	// TODO: Should be removed/refactored in the future
	// Keeping old logic, to always include table option, to avoid breaking existing features (ITLs)
	// Adding flag to remove it if needed
	if (!options?.hideTableOption) {
		insertItems = [...insertItems, 'Table'];
	}

	return { name: 'insert', items: insertItems };
};
